module.exports = __webpack_public_path__ + "media/images/pc/articles/popular_contents_plans-24e9c6c50e7d13f0a520aecf2f87c6ae.webp";